import { type ReactNode } from 'react';
import { useMedia } from 'react-use';
import { OldModal } from '@hungryroot/ramen';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import { Sheet } from '../Sheet/Sheet';

interface Props {
  children: ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  innerContentClassName?: string;
  closeButtonClassName?: string;
  onDismiss: () => void;
  ariaLabel: string;
  testid?: string;
  isOpen: boolean;
  contentBodyClassName?: string;
  swipeCloseSegmentEvent?: () => void;
  clickOffSegmentEvent?: () => void;
  clickCloseSegmentEvent?: () => void;
  showXButton?: boolean;
}

/**
 * @deprecated Use Ramen instead
 * @param props
 * @returns
 */
export function SheetOrModal(props: Props) {
  const {
    isOpen,
    children,
    testid,
    ariaLabel,
    onDismiss,
    contentClassName,
    contentBodyClassName,
    overlayClassName,
    swipeCloseSegmentEvent,
    clickOffSegmentEvent,
    clickCloseSegmentEvent,
    innerContentClassName,
    closeButtonClassName,
    showXButton,
  } = props;
  const isDesktop = useMedia(BreakpointQueryLarge);

  if (isDesktop === true) {
    return (
      <OldModal
        contentClassName={contentClassName}
        overlayClassName={overlayClassName}
        innerContentClassName={innerContentClassName}
        closeButtonClassName={closeButtonClassName}
        onDismiss={onDismiss}
        ariaLabel={ariaLabel}
        showXButton={showXButton}
        testid={testid}
        isOpen={isOpen}
        clickOffSegmentEvent={clickOffSegmentEvent}
        clickCloseSegmentEvent={clickCloseSegmentEvent}
      >
        {children}
      </OldModal>
    );
  }

  return (
    <Sheet
      contentClassName={contentClassName}
      className={overlayClassName}
      initialFocusRef={undefined}
      onRequestDismiss={onDismiss}
      ariaLabel={ariaLabel}
      testid={testid}
      active={isOpen}
      contentBodyClassName={contentBodyClassName}
      swipeCloseSegmentEvent={swipeCloseSegmentEvent}
      showXButton={showXButton}
    >
      {children}
    </Sheet>
  );
}
